export default __webpack_public_path__ + "static/media/ideas_3.2f9c38cf.png";